<template>
  <div>
        <v-card-title class="grey--text">
              <div class="display-1" style="width:100%">Booking <span class="display-1 primary--text px-1"> {{ booking.id }}</span></div>
        </v-card-title>
        <m-distance-detail v-if="booking.json && booking.type" :booking="booking.json" :type="booking.type"></m-distance-detail>



          <div class="subheading black--text pl-4 pb-2" style="width:100%">

          Price: <span class="subheading primary--text px-1"> {{ booking.price_driver | currency}}</span>

          </div>

              <div v-if="booking.factuur === 1" class="subheading black--text pl-4 pb-2" style="width:100%">

               Factuur: <span class="subheading primary--text px-1"> oui</span>

              </div>

              <div v-if="booking.mutualPatientID" class="subheading black--text pl-4 pb-2" style="width:100%">
                <div class="mutualPatient">
                  <span class="subheading primary--text px-1">Attestation mutuelle obligatoire </span><br>
                  <span v-if="booking.mutualPatientID && booking.factuur != 1">
                    Client paye: <span class="subheading primary--text px-1"> {{ booking.mutualPatientAmount | currency(true) }}</span>
                </span>
               </div>
              </div>

              <div v-if="booking.waitprice > 0" class="subheading black--text pl-4 pb-2" style="width:100%">

               Prix acc.: <span class="subheading primary--text px-1"> {{ booking.waitprice | currency }}</span> ( {{ booking.ap_waittime | formatTime }} )

              </div>

            <div class="booking-detail subheading black--text pl-4 pb-2" style="width:100%">

              Comment: <span class="grey--text px-1"> {{ booking.comment }}</span>

              </div>

          <v-divider></v-divider>
      </div>
</template>
<script>
import MDistanceDetails from '@/components/booking/distance_details';
import Auth from '@/core/auth';
export default {
  props: ['booking'],
  components: {
    'm-distance-detail': MDistanceDetails
  },
  data () {
    return {
      item: {},
      price: 0
    }
  },
  computed: {
    driver: Auth.getUser
  },
  methods: {
    getdata () {
      var app = this;
      var id = this.id;
      console.log('update destination detail');
      this.$http
      .get('api/destination/' + id)
      .then(response => {
        console.log('response destination data:', response.data);
        app.item = response.data[0];
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    }
  },
  watch: {
    booking () {
      console.log('updated destination id:', this.id)
      this.price = ((this.booking.json.totals[this.booking.type].price) === this.booking.price) ? 0 : this.booking.price;
      // this.getdata();
    }
  },
  created () {
    // this.getdata();
  }
}
</script>
<style lang="scss">
  .booking-detail{
    table.table thead tr {
        height: 24px;
    }
    table.table tbody td, table.table tbody th {
        height: 18px;
    }
    tr.result {
      height: 38px;
      td {
        font-size: 18px;
      }

    }
  }

  .mutualPatient {
    border: solid 1px red;
    padding: 8px;
    display: inline-block;
  }
</style>
